// ai slice

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  responses: {}, // Store responses by prompt
  isFetching: {},
  isSuccess: {},
  isError: {},
  errorMessage: {},
};

export const getAiPromptResponse = createAsyncThunk(
  'ai/get_ai_prompt_response',
  async ({ prompt, ...bodyParam }, thunkAPI) => {
    try {
      const response = await axios.get('/api/ai', {
        params: { prompt, ...bodyParam },
      });
      const { data } = await response;

      if (!response.data.error) {
        return { prompt, data }; // Include prompt in response
      } else {
        const { error } = await response.data;
        return thunkAPI.rejectWithValue({ prompt, error });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({
        prompt,
        error: error.response.data,
      });
    }
  }
);

export const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAiPromptResponse.pending, (state, action) => {
      const prompt = action.meta.arg.prompt;
      state.isFetching[prompt] = true;
      state.isSuccess[prompt] = false;
      state.isError[prompt] = false;
      state.errorMessage[prompt] = '';
    });
    builder.addCase(getAiPromptResponse.fulfilled, (state, { payload }) => {
      const { prompt, data } = payload;
      state.isFetching[prompt] = false;
      state.isSuccess[prompt] = true;
      state.responses[prompt] = data.result;
    });
    builder.addCase(getAiPromptResponse.rejected, (state, action) => {
      const { prompt, error } = action.payload;
      state.isFetching[prompt] = false;
      state.isSuccess[prompt] = false;
      state.isError[prompt] = true;
      state.errorMessage[prompt] = error;
    });
  },
});

export const aiSelector = (state) => state.ai;
